<script lang="ts" setup>
import Navbar from './Navbar.vue';
import Footer from './Footer.vue';
import { computed } from 'vue';
import { isInAppEnvironment } from '@/pages/course/composables/coursePlay/utils';

// 判断是否在 app 环境
const isInApp = computed(() => isInAppEnvironment());
</script>

<template>
  <div class="layout">
    <Navbar v-if="!isInApp" />
    <div class="layout-container">
      <router-view />
    </div>
    <Footer v-if="!isInApp" />
  </div>
</template>

<style lang="scss" scoped>
.layout {
  position: relative;
}
.layout-container {
  min-height: calc(100vh - 212px);
}
</style>
